export default {
  sectionTitle: 'Claim Stages Configuration',
  sectionDescription: 'Define and manage the stages that guide your claims from start to resolution.',
  emptyStateTitle: 'No claim stages yet',
  emptyStateDescription: 'Start building your claims workflow by adding the first stage.',
  createStage: 'Create Stage',
  addStage: 'Add Stage',
  editStage: 'Edit Stage',
  required: 'Required',
  keyMustBeUnique: 'Key must be unique',
  keyMustMatchPattern: 'Key may only contain lowercase letters, numbers and underscores',
  keyMustContainLetterOrNumber: 'Key must contain at least one letter or number',
  cancel: 'Cancel',
  save: 'Save',
  initial: 'Initial',
  listChangedOnMove: 'The stages were changed elsewhere and have been reloaded. Please make your move again.',
  labels: {
    label: 'Label',
    key: 'Key',
    color: 'Color',
    initial: 'Set as initial stage',
  },
  columns: {
    color: 'Color',
    key: 'Key',
    label: 'Label',
    enabled: 'Enabled',
    actions: 'Actions',
  },
} as const;
